'use client';

import { Trans } from '@lingui/macro';
import ArrowRightIcon from '@mui/icons-material/ArrowRight';
import {
  ListItemIcon,
  ListItemText,
  MenuItem,
  Typography,
} from '@mui/material';
import type { FC } from 'react';

type Props = {
  name?: string | undefined;
  redirectTo?: string | undefined;
  order?: number;
};

export const RessourcesItem: FC<Props> = (props: Props) => {
  const { name, redirectTo, order = 10 } = props;

  // if (!name || !redirectTo) {
  //   return null;
  // }

  return (
    <MenuItem
      component="a"
      href="/guides/guide-utilisation"
      target="_blank"
      sx={{ order, paddingY: 2 }}
    >
      <ListItemText sx={{ flex: 1 }}>
        <Typography display="inline">
          <Trans>Guide</Trans>
        </Typography>
      </ListItemText>
    </MenuItem>
  );
};
